import axios from 'axios';
import { apiUrl } from '../constant';

export const getAllCustomPricingTemplates = (data) => {
    return axios.post(`${apiUrl}/api/CustomTemplate/FilterCustomTemplates`, data, {
        headers: {
            'Content-Type': 'application/json-patch+json',
            accept: '*/*',
        },
    });
};

export const getCustomPricingTemplateById = (id) => {
    return axios.get(`${apiUrl}/api/CustomTemplate/GetCustomTemplate/${id}`, {
        headers: {
            accept: '*/*',
        },
    });
};

export const createUpdateCustomPricingTemplateService = (data) => {
    return axios.post(`${apiUrl}/api/CustomTemplate/AddUpdateTemplates`, data, {
        headers: {
            'Content-Type': 'application/json-patch+json',
            accept: '*/*',
        },
    });
};

export const deleteCustomPricingTemplateService = (id) => {
    return axios.delete(`${apiUrl}/api/CustomTemplate/DeleteCustomTemplate/${id}`);
};
